import { render, staticRenderFns } from "./pendingPromoCode.vue?vue&type=template&id=3222febb&scoped=true"
import script from "./pendingPromoCode.vue?vue&type=script&lang=js"
export * from "./pendingPromoCode.vue?vue&type=script&lang=js"
import style0 from "./pendingPromoCode.vue?vue&type=style&index=0&id=3222febb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3222febb",
  null
  
)

export default component.exports